import { Tooltip } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ConvertToText,
  CopyButton,
  RefreshIcon,
  ThumbsDown,
  ThumbsUp,
} from "../../config/Icons";
import Button from "../Button";
import styles from "./index.module.scss";

function AiSummarySkeleton() {
  return (
    <div className={styles.skeletonBox}>
      <div className={styles.line} />
      <div className={styles.line} />
      <div className={styles.line} />
    </div>
  );
}

function IconButton({ onClick, label, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={styles.footerButton}
    >
      {children}
    </button>
  );
}

export default function AiSummaryBox({
  summary,
  isLoading,
  isError,
  handleTryAgain,
  handleLike,
  handleDislike,
  handleCopy,
  handleInsert,
}) {
  const { t } = useTranslation();
  const [feedback, setFeedback] = useState(null); // "like" | "dislike" | null
  const [copied, setCopied] = useState(false);
  const onCopy = () => {
    handleCopy?.();
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  // summary = "test";

  if (isLoading) {
    return <AiSummarySkeleton />;
  }

  return (
    <div className={styles.summaryBox}>
      <p>
        {isError
          ? t("reviewSession.failedToGenerateSummary")
          : summary || t("reviewSession.failedToGenerateSummary")}
      </p>
      {isError ? (
        <div className={styles.failFooter}>
          <IconButton onClick={handleTryAgain} label="Try Again">
            <RefreshIcon className={styles.footerIcon} />
            <span>{t("reviewSession.tryAgain")}</span>
          </IconButton>
        </div>
      ) : (
        <div className={styles.summaryFooter}>
          <Tooltip title={t("aiPopover.helpful")} placement="top" classes={{ tooltip: styles.tooltip }}>
            <span>
              <ThumbsUp
                className={`${styles.footerIcon} ${styles.thumbsUpIcon} ${feedback === "like" ? styles.active : ""}`}
                onClick={() => { setFeedback("like"); handleLike?.(); }}
              />
            </span>
          </Tooltip>
          <Tooltip title={t("aiPopover.notHelpful")} placement="top" classes={{ tooltip: styles.tooltip }}>
            <span>
              <ThumbsDown
                className={`${styles.footerIcon} ${styles.thumbsDownIcon} ${feedback === "dislike" ? styles.active : ""}`}
                onClick={() => { setFeedback("dislike"); handleDislike?.(); }}
              />
            </span>
          </Tooltip>
          <Tooltip title={copied ? t("aiPopover.copied") : t("aiPopover.copy")} placement="top" classes={{ tooltip: styles.tooltip }}>
            <span>
              <CopyButton className={styles.footerIcon} onClick={onCopy} />
            </span>
          </Tooltip>
          <Button
            variant="outlined"
            className={styles.insertButton}
            onClick={handleInsert}
          >
            <ConvertToText className={styles.insertIcon} />
            {t("reviewSession.insert")}
          </Button>
        </div>
      )}
    </div>
  );
}
